export default {
    mainContainer:{
        display: "flex",
        flexDirection: "column",
        overflow: 'hidden',
    },
    secondLevelContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    dashboardContainer: {
        display: 'flex',
        width: "100%",
        height: "calc(100vh - 73px)",
    },
    dashboardBody: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        width: "100%",
    },
}